import React from 'react';

const CommonDetailsPageSectionTitle = ({ children }) => (
    <h3 className="mt-0 mb-3 font-public-sans font-weight-600 fs-18">
        {children}
    </h3>
);
export default CommonDetailsPageSectionTitle;
